import { useFormContext } from 'react-hook-form';
import type { PostgresConfigWithInstances } from '@/enteties/postgresql/model';
import { useEffect } from 'react';
import { CnpgConfigFields } from 'features/set-cnpg-config/ui/cnpg-config-fields';
export const CnpgComponent = ({
  disabled
}: {
  disabled: boolean;
}) => {
  const form = useFormContext<PostgresConfigWithInstances>();
  useEffect(() => {
    form.reset({
      postgresVersion: '',
      superuserPassword: '',
      enableSuperuserAccess: false,
      instances: 1
    }, {
      keepDirtyValues: true
    });
  }, []);
  return <CnpgConfigFields disabled={disabled} withInstances data-sentry-element="CnpgConfigFields" data-sentry-component="CnpgComponent" data-sentry-source-file="cnpg-config.tsx" />;
};